"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusNoCircleIcon = void 0;
const react_1 = __importDefault(require("react"));
const PlusNoCircleIcon = (_a) => {
    var { onClick, fill } = _a, props = __rest(_a, ["onClick", "fill"]);
    return (react_1.default.createElement("svg", Object.assign({ width: "11", height: "11", viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { onClick: onClick }),
        react_1.default.createElement("path", { d: "M1 4.5C0.447715 4.5 0 4.94772 0 5.5C0 6.05228 0.447715 6.5 1 6.5V4.5ZM10 6.5C10.5523 6.5 11 6.05228 11 5.5C11 4.94772 10.5523 4.5 10 4.5V6.5ZM6.5 1C6.5 0.447715 6.05228 0 5.5 0C4.94772 0 4.5 0.447715 4.5 1H6.5ZM4.5 10C4.5 10.5523 4.94772 11 5.5 11C6.05228 11 6.5 10.5523 6.5 10H4.5ZM1 6.5H5.5V4.5H1V6.5ZM5.5 6.5H10V4.5H5.5V6.5ZM4.5 1V5.5H6.5V1H4.5ZM4.5 5.5V10H6.5V5.5H4.5Z", fill: fill })));
};
exports.PlusNoCircleIcon = PlusNoCircleIcon;
